import React, { Dispatch, SetStateAction, useContext } from "react";

import { dropdownModalContext } from "@/app/(main)/(club)/mes-clubs/[id]/leads/context/dropdown-modal-provider";
import Icon from "@/components/icon";
import {
  ClubRead,
  LeadRead,
  MemberRead,
} from "@/TS/Interfaces/global_interfaces";

export const handleFilter = (members: MemberRead[], valueSort: string) => {
  const sortedArray = [...members];
  switch (valueSort) {
    case "asc":
      return sortedArray.sort((a, b) => {
        return a.lastName.toLowerCase() < b.lastName.toLowerCase() ? -1 : 1;
      });
    case "desc":
      return sortedArray.sort((a, b) => {
        return a.lastName.toLowerCase() > b.lastName.toLowerCase() ? -1 : 1;
      });

    case "publish":
      return sortedArray.sort((a, b) => {
        return b.publishedLeads - a.publishedLeads;
      });
    case "transform":
      return sortedArray.sort((a, b) => {
        return b.transformedLeads - a.transformedLeads;
      });
    case "dispatch":
      return sortedArray.sort((a, b) => {
        return b.invitationsDispatched - a.invitationsDispatched;
      });
  }
  return sortedArray;
};

export const handleArray = (club: ClubRead) => {
  return [
    { label: "Accueil", href: "/" },
    { label: "/ Mes Clubs d'affaires", href: "/mes-clubs/" },
    {
      label: club.displayName,
      href: "/mes-clubs/" + club.slug,
    },
    {
      label: "/ Membres du club",
      href: "/mes-clubs/" + club.slug + "/members",
    },
  ];
};

export const filterOptions = ({
  setIsOpen,
}: {
  isOpen?: boolean;
  setIsOpen?: Dispatch<SetStateAction<boolean>>;
}) => (
  <>
    <div className="flex flex-col px-4 md:hidden">
      <div className="flex font-bold justify-between">
        <h3>TRIER</h3>
        <Icon onClick={() => setIsOpen!(false)} icon={"cross"} size={33}></Icon>
      </div>
      <div className="h-[2px] mt-2 bg-light-grey"></div>
    </div>
    <label
      className={
        "hover:bg-light-grey p-4 py-3 transition-all cursor-pointer has-[:checked]:bg-light-grey"
      }
      htmlFor="asc"
    >
      <input
        className={"hidden checked:bg-light-grey"}
        type="radio"
        name={"sort"}
        id={"asc"}
        value={"asc"}
      />
      Afficher par nom (A-Z)
    </label>
    <label
      className={
        "hover:bg-light-grey p-4 cursor-pointer has-[:checked]:bg-light-grey"
      }
      htmlFor="desc"
    >
      <input
        className={"hidden peer"}
        type="radio"
        id={"desc"}
        name={"sort"}
        value={"desc"}
      />
      Afficher par nom (Z-A)
    </label>
    <label
      className={
        "hover:bg-light-grey p-4 py-3 transition-all cursor-pointer has-[:checked]:bg-light-grey"
      }
      htmlFor="publish"
    >
      <input
        className={"hidden checked:bg-light-grey"}
        type="radio"
        id={"publish"}
        name={"sort"}
        value={"publish"}
      />
      Nombre de leads publiés
    </label>
    <label
      className={
        "hover:bg-light-grey p-4 py-3 transition-all cursor-pointer has-[:checked]:bg-light-grey"
      }
      htmlFor="transform"
    >
      <input
        className={"hidden peer"}
        type="radio"
        id={"transform"}
        name={"sort"}
        value={"transform"}
      />
      Nombre de leads transformés
    </label>
    <label
      className={
        "hover:bg-light-grey p-4 py-3 transition-all cursor-pointer has-[:checked]:bg-light-grey"
      }
      htmlFor="dispatch"
    >
      <input
        className={"hidden peer"}
        type="radio"
        id={"dispatch"}
        name={"sort"}
        value={"dispatch"}
      />
      Nombre d'invitations envoyées
    </label>
  </>
);

export const FilterOptionsContainer = (
  setter: Dispatch<SetStateAction<string>>,
) => {
  const { dropData } = useContext(dropdownModalContext);

  return (
    <div
      className={"flex flex-col"}
      onChange={(e) => setter((e.target as HTMLInputElement).value)}
    >
      {filterOptions({
        isOpen: dropData?.isOpen,
        setIsOpen: dropData?.setIsOpen,
      })}
    </div>
  );
};

export const numberPhoneStringToFrenchFormat = (
  numberPhone: string,
): string => {
  return numberPhone
    .split("")
    .map((n, i) => {
      if (i % 2 === 1) {
        return n + " ";
      } else return n;
    })
    .join("");
};

export const memberOptions = (
  memberId: string,
  handleMemberShow: (memberId: string) => void,
  handleMemberEdit: (memberId: string) => void,
  _selfIsPresident = false,
  profile: MemberRead,
) => (
  <>
    {/* {selfIsPresident ? (
      <>
        <label
          className={
            "hover:bg-light-grey px-6 py-3 transition-all cursor-pointer has-[:checked]:bg-light-grey"
          }
          htmlFor="my-profile"
          onClick={() => handleMemberShow(memberId)}
        >
          <input
            className={"hidden checked:bg-light-grey"}
            type="radio"
            name={"sort"}
            id={"my-profile"}
            value={"my-profile"}
          />
          Voir mon profil
        </label>
        <label
          className={
            "hover:bg-light-grey px-6 py-3 transition-all cursor-pointer has-[:checked]:bg-light-grey"
          }
          htmlFor="update-my-profile"
          onClick={() => handleMemberEdit(memberId)}
        >
          <input
            className={"hidden peer"}
            type="radio"
            id={"update-my-profile"}
            name={"sort"}
            value={"update-my-profile"}
          />
          Mettre à jour mon profil
        </label>
      </>
    ) : ( */}
    <>
      <label
        className={
          "hover:bg-light-grey p-4 py-3 transition-all cursor-pointer has-[:checked]:bg-light-grey"
        }
        htmlFor="his-profile"
        onClick={() => handleMemberShow(memberId)}
      >
        <input
          className={"hidden checked:bg-light-grey"}
          type="radio"
          name={"sort"}
          id={"his-profile"}
          value={"his-profile"}
        />
        {profile?.canUpdateProfile ? "Voir mon profil" : "Voir le profil"}
      </label>
      {profile?.canUpdateProfile && (
        <label
          className={
            "hover:bg-light-grey px-4 py-3 transition-all cursor-pointer has-[:checked]:bg-light-grey"
          }
          htmlFor="update-my-profile"
          onClick={() => handleMemberEdit(memberId)}
        >
          <input
            className={"hidden peer"}
            type="radio"
            id={"update-my-profile"}
            name={"sort"}
            value={"update-my-profile"}
          />
          Mettre à jour mon profil
        </label>
      )}
    </>
    {/* )} */}
    {/*<label*/}
    {/*  className={*/}
    {/*    "hover:bg-light-grey p-4 py-3 transition-all cursor-pointer has-[:checked]:bg-light-grey"*/}
    {/*  }*/}
    {/*  htmlFor="update-his-profile"*/}
    {/*>*/}
    {/*  <input*/}
    {/*    className={"hidden peer"}*/}
    {/*    type="radio"*/}
    {/*    id={"update-his-profile"}*/}
    {/*    name={"sort"}*/}
    {/*    value={"update-his-profile"}*/}
    {/*  />*/}
    {/*  Mettre à jour le profil du membre*/}
    {/*</label>*/}
    {/*<label*/}
    {/*  className={*/}
    {/*    "hover:bg-light-grey p-4 py-3 transition-all cursor-pointer has-[:checked]:bg-light-grey"*/}
    {/*  }*/}
    {/*  htmlFor="his-contract"*/}
    {/*>*/}
    {/*  <input*/}
    {/*    className={"hidden checked:bg-light-grey"}*/}
    {/*    type="radio"*/}
    {/*    id={"his-contract"}*/}
    {/*    name={"sort"}*/}
    {/*    value={"his-contract"}*/}
    {/*  />*/}
    {/*  Consulter le contract*/}
    {/*</label>*/}
  </>
);

export const getStatusDate = (lead: LeadRead): Date | undefined => {
  switch (lead.status) {
    case "transformed":
      return new Date(lead.transformedAt ?? NaN);
    case "accepted":
      return new Date(lead.acceptedAt ?? NaN);
    case "sent":
      return new Date(lead.createdAt ?? NaN);
    case "cancelled":
      return new Date(lead.cancelledAt ?? NaN);
    case "not_transformed":
      return new Date(lead.notTransformedAt ?? NaN);
    case "refused":
      return new Date(lead.refusedAt ?? NaN);
  }
};
